var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"external-resource-view",staticStyle:{"height":"100%"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.$route.query.url,"id":"mobsf","frameborder":"0"}}),_c('span',{staticClass:"home-button"},[_c('el-button',{attrs:{"icon":"el-icon-s-home","circle":""},on:{"click":_vm.skipHome}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }